import ManagePlan from '@Views/Settings/billing-settings/ManagePlan';
import { useDynamicUI } from './useDynamicUI';
import { createElement } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { pricesQueryOptions } from '@utils/queryOptions';

const useManagePlan = () => {
    const open = useDynamicUI();
    const queryClient = useQueryClient();

    const handleOpen = async () => {
        await queryClient.ensureQueryData(pricesQueryOptions());
        open(onClose => createElement(ManagePlan, { open: true, onClose }));
    };

    return handleOpen;
};

export default useManagePlan;
